import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class ClubService {
  static async update(id, data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation CLUB_UPDATE(
          $id: String!
          $data: ClubInput!
        ) {
          clubUpdate(id: $id, data: $data) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
      },
    });

    return response.data.clubUpdate;
  }

  static async destroyAll(ids) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation CLUB_DESTROY($ids: [String!]!) {
          clubDestroy(ids: $ids)
        }
      `,

      variables: {
        ids,
      },
    });

    return response.data.clubDestroy;
  }

  static async create(data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation CLUB_CREATE($data: ClubInput!) {
          clubCreate(data: $data) {
            id
          }
        }
      `,

      variables: {
        data,
      },
    });

    return response.data.clubCreate;
  }

  static async import(values, importHash) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation CLUB_IMPORT(
          $data: ClubInput!
          $importHash: String!
        ) {
          clubImport(data: $data, importHash: $importHash)
        }
      `,

      variables: {
        data: values,
        importHash,
      },
    });

    return response.data.clubImport;
  }

  static async find(id) {
    const response = await graphqlClient.query({
      query: gql`
        query CLUB_FIND($id: String!) {
          clubFind(id: $id) {
            id
            name
            logo {
              id
              name
              sizeInBytes
              publicUrl
              privateUrl
            }
            teams {
              id
            }
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
      },
    });

    return response.data.clubFind;
  }

  static async list(filter, orderBy, limit, offset) {
    const response = await graphqlClient.query({
      query: gql`
        query CLUB_LIST(
          $filter: ClubFilterInput
          $orderBy: ClubOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          clubList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id
              name
              logo {
                id
                name
                sizeInBytes
                publicUrl
                privateUrl
              }
              teams {
                id
              }
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
      },
    });

    return response.data.clubList;
  }

  static async listAutocomplete(query, limit) {
    const response = await graphqlClient.query({
      query: gql`
        query CLUB_AUTOCOMPLETE(
          $query: String
          $limit: Int
        ) {
          clubAutocomplete(query: $query, limit: $limit) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
      },
    });

    return response.data.clubAutocomplete;
  }
}
